<template>
    <div class="row new-comment-row">
        <div class="col-12">
            <div class="comment-area">
                <ui-textbox 
                    :disabled="isLoading" 
                    v-model="comment" 
                    multi-line 
                    :rows="1" 
                    placeholder="Write a comment..."
                ></ui-textbox>
            </div>
        </div>
        <div class="col-12">
            <ui-button :loading="isLoading" @click="save">Save Comment</ui-button>
        </div>
    </div>
</template>

<style lang="scss">
    .new-comment-row {
        .comment-area {
            box-shadow: 0 1px 2px -1px rgba(9,45,66,.25), 0 0 0 1px rgba(9,45,66,.08); 
            padding: 1rem; margin-bottom: 1rem; border-radius: 3px;

            .ui-textbox { margin-bottom: 0; }
        }
    }
</style>

<script>
    export default {
        props: {
            isLoading: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                comment: ''
            }
        },
        methods: {
            save() {
                this.$emit('save', this.comment)
            },
            reset() {
                this.comment = ''
            }
        }
    }
</script>